export const ROOT_SETTINGS = {
    properties: [],
    style: [],
    events: [],
};
